import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MailInsert } from 'src/app/shared/models/iCourrier/post/mail-insert';
import { MailDTO } from '../interfaces/mails/mail-dto.interface';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MailsReplyService {
  private url: string;

  constructor(private http: HttpClient) {
    const config = environment;
    this.url = config.apiICourrierBaseUrl;
  }

  quickReplyMail(id: number, mail: MailInsert, skipWarns?: boolean): Observable<MailDTO> {
    let params = new HttpParams();
    if (skipWarns) {
      params = new HttpParams().set('skipWarns', skipWarns.toString());
    }
    return this.http.post<MailDTO>(`${this.url}/Mails/${id}/Replies/QuickReply?${params}`, mail);
  }

  // Full reply to mail with files
  fullReplyMail(id: number, mail: MailInsert, skipWarns?: boolean): Observable<MailDTO> {
    const body = new FormData();
    for (const property in mail) {
      if (Object.prototype.hasOwnProperty.call(mail, property)) {
        if (property === 'Files') {
          mail[property].map((item) => {
            body.append('Files', item);
          });
        }
        if (property === 'autoDistributionServices') {
          body.append('autoDistributionServices', JSON.stringify(mail[property]));
        }

        if (property === 'autoDistributionbUsers') {
          body.append('autoDistributionbUsers', JSON.stringify(mail[property]));
        }
        if (property === 'NatureCustomDatas') {
          // This could be made fancier but it explains how to fix the problem
          mail['NatureCustomDatas'].forEach((obj, index) => {
            Object.keys(obj).forEach((key) => {
              if (obj[key] !== null) {
                body.append(`NatureCustomDatas[${index}].${key}`, obj[key]);
              }
            });
          });
        }
        if (property === 'lien') {
          body.append('lien.linkCourrierId', mail[property].linkCourrierId);
          body.append('lien.typeLiaison', mail[property].typeLiaison);
        }
        if (
          property !== 'Files' &&
          property !== 'autoDistributionServices' &&
          property !== 'autoDistributionbUsers' &&
          property !== 'NatureCustomDatas' &&
          property !== 'lien'
        ) {
          body.append(property, mail[property]);
        }
      }
    }

    let params = new HttpParams();
    if (skipWarns) {
      params = new HttpParams().set('skipWarns', skipWarns.toString());
    }
    return this.http.post<MailDTO>(`${this.url}/Mails/${id}/Replies/FullReply?${params}`, body);
  }
}
